import { render, staticRenderFns } from "./saldiscountbaseinfo.vue?vue&type=template&id=795de4ee&scoped=true&"
import script from "./saldiscountbaseinfo.vue?vue&type=script&lang=js&"
export * from "./saldiscountbaseinfo.vue?vue&type=script&lang=js&"
import style0 from "./saldiscountbaseinfo.vue?vue&type=style&index=0&id=795de4ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795de4ee",
  null
  
)

export default component.exports